import axiosInstance from "@/api/axios";
import toastService from "@/services/toastService";
// import mockLeads from "../mockLeads";

export interface API_RESPONSE {
  id: number;
  stage_id: [number, string];
  expected_revenue: number;
  prorated_revenue: number;
  display_name: string;
  partner_name: string;
  contact_name: string;
  priority: string;
  color: number;
  activity_type_id: [number, string];
  activity_type_icon: string;
  activity_summary: string;
  activity_state: string;
  company_currency: [number, string];
  tags: {
    id: number;
    name: string;
    display_name: string;
  }[];
}

export interface Lead {
  name: string;
  applicant_email: string;
  applicant_phone: string;
  id: number;
  activity_type_id: [number, string];
  activity_type_icon: string;
  activity_summary: string;
  activity_state: string;
  active: boolean;
  activity_calendar_event_id: string;
  activity_date_deadline: string;
  activity_exception_decoration: string;
  activity_exception_icon: string;
  activity_ids: Array<unknown> | null;
  activity_user_id: string;
  avatar_url: string;
  additional_info: string;
  stage_id: [number, string];
  expected_revenue: number;
  prorated_revenue: number;
  display_name: string;
  partner_name: string;
  contact_name: string;
  priority: string;
  color: number;
  company_currency: [number, string];
  tags: {
    id: number;
    name: string;
    display_name: string;
  }[];
  longitude?: string;
  latitude?: string;
  description?: string;
  city?: string;
  city_id?: [number, string];
  state_id: [number, string];
  country_id: [number, string];
  province_id: [number, string];
  region: string;
  address?: string;
  image_url?: string[];
  project_image_ids: { id: number; image_url: string }[];
  permit_issue_date: string;
  project_type_id: [number, string];
  project_class_id: [number, string];
  project_status_id: [number, string];
  owner_email: string;
  owner_company: string;
  owner_name: string;
  applicant_company: string;
  owner_phone: string | boolean;
  project_description: string;
  user_id: [number, string];
  company_id: [number, string];
  builder_id: [number, string];
  user_avatar: string;
  probability: number;
  builder: {
    builder_company: string;
    id: number;
    partner_id: [number, string];
    company_id: [number, string];
    organization_id: boolean;
    name: string;
    phone: string;
    email: string;
    display_name: string;
    create_uid: [number, string];
    create_date: string;
    write_uid: [number, string];
    write_date: string;
    company_details: Builder_Company_Details;
  };
  color_hex?: string;
  applicant_name: string;
  create_date: string;
}
export interface Builder_Company_Details {
  name: string;
}

export interface Stage {
  id: number;
  name: string;
  sequence: number;
  is_won: boolean;
  requirements: boolean;
  team_id: number;
  fold: boolean;
  team_count: number;
  display_name: string;
  create_uid: [number, string];
  create_date: string;
  write_uid: [number, string];
  write_date: string;
}

export interface Column extends Omit<IStageGroup, "id"> {
  id: number | string;
  name: string;
  sequence?: number;
  // is_won: boolean;
  // requirements: boolean;
  // team_id: number;
  // fold: boolean;
  // team_count: number;
  // display_name: string;
  // create_uid: [number, string];
  // create_date: string;
  // write_uid: [number, string];
  // write_date: string;
  items: Lead[];
  lead_ids?: Array<number>;
  limit?: number;
  nextPage?: number;
  is_won?:boolean;
  is_lost?:boolean;
  is_archive_lead?:boolean;
  count: number;
}

export interface IStageGroup {
  color: number;
  count: number;
  expected_revenue: number;
  id: string | number;
  name: string;
  probability: number;
  progress_bar: {
    today: number;
    overdue: number;
    planned: number;
  };
  recurring_revenue_monthly: number;
  stage_id: [number, string];
  stage_id_count: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __domain: Array<any>;
  __fold: boolean;
  is_archive_lead?:boolean
}

export type PROGRESS_BAR = {
  color: number | boolean;
  count: number;
  expected_revenue: number;
  id: string | number;
  name: string;
  overdue: number;
  planned: number;
  recurring_revenue_monthly: number;
  today: number;
};

export type Attendee = {
  id: number;
  name: string;
};

export const fetchPartners = async (params?: {
  page?: number;
  limit?: number;
  q?: string;
  includingEmail?: boolean;
}) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/partners",
      params: {
        ...(params?.page !== undefined && { page: params.page }),
        ...(params?.limit !== undefined && { limit: params.limit }),
        ...(params?.q && { q: params.q }),
        ...(params?.includingEmail == true && {
          includingEmail: params.includingEmail,
        }),
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export function formatPrice(amount: number): string {
  // Handle different number ranges and format accordingly
  if (amount >= 1_000_000) {
    const result = (amount / 1_000_000).toFixed(1);
    return result.endsWith(".0")
      ? `${Math.floor(amount / 1_000_000)}M `
      : `${result}M `; // For millions
  } else if (amount >= 1_000) {
    const result = (amount / 1_000).toFixed(1);
    return result.endsWith(".0")
      ? `${Math.floor(amount / 1_000)}K `
      : `${result}K `; // For thousands
  } else {
    return amount.toString(); // Return the number as is if less than 1,000
  }
}

export const getStages = async () => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/stages/v2",
      data:{
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }
    });
    console.log("stages v2 response", response);
    return response.data.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};
export const getStageColor = async () => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/crm/leads/color",
    });
    console.log("response", response);
    // setColumns(response.data.data.data.stages);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};
export const updateLeadColor = async (data: {
  leadId: number;
  colorId: number;
}) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: "/odoo/api/v1/crm/leads/color",
      data: data,
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const enrichLeadService = async (data: { leadId: number }) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/ai/enrichmentData",
      // data: data,
      params: { ...data, leadType: "crm" },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const addStage = async (data: { name: string; displayName: string }) => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/stages",
      data: data,
    });
    console.log("response", response);
    // setColumns(response.data.data.data.stages);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};

export const getLeads = async (params?: object) => {
  console.log("params", params);
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/crm/leads",
      params: params,
    });

    console.log("response", response);

    return response.data.data;
  } catch (err) {
    console.log("get Leads call err", err);
  }
};

export const getLeadsV3 = async (data: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  domain: Array<any>;
  page: number;
  limit: number;
}) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/fetch/v3",
      data: data,
    });

    return response.data;
  } catch (err) {
    console.log("get Leads call err", err);
  }
};

export const getLeadsByActivityType = async (data: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  domain: Array<any>;
  activityType: string;
  page: number;
  limit: number;
}) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/fetchByActivityType",
      data: data,
    });

    return response.data;
  } catch (err) {
    console.log("get Leads by activity type call err", err);
  }
};

export const getLeadsV2 = async (data: {
  filters: Partial<{
    q: string;
    city: Array<string>;
    province: Array<string>;
    stage_id: number;
    stage_ids: Array<number>; // Only 1 of either stage_id and stage_ids
    permit_issue_date: {
      start: string;
      end: string;
    };
  }>;
  page: number;
  limit: number;
}) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/v2",
      data: data,
    });

    return response.data;
  } catch (err) {
    console.log("get Leads call err", err);
  }
};

export const deleteStage = async (data: { stageId: number }) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/crm/stages/delete`,
      data: data,
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const changeLeadStage = async (
  leadId: string | number,
  stageId: number
) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: `/odoo/api/v1/crm/leads/changeStage`,
      data: { leadId: Number(leadId), stageId: stageId },
    });
    console.log("response", response);
  } catch (err) {
    console.log("err", err);
  }
};

export const changeStageSequence = async (data: object) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: `/odoo/api/v1/crm/stages/sequence`,
      data: data,
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const removeProjectLead = async (data: object) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/delete",
      // params: params,
      // data: data,
      data: data,
    });

    console.log("response", response);

    return response;
  } catch (err) {
    console.log("err", err);
  }
};

export const addTags = async (data: object) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/tag",
      // params: params,
      // data: data,
      data: data,
    });

    console.log("response", response);

    return response;
  } catch (err) {
    console.log("err", err);
  }
};

// export const getTimeLine = async()

// export const getTimeline = async (
//   leadId: string | number,
// ) => {
//   try {
//     const response = await axiosInstance({
//       method: "GET",
//       url: `/odoo/api/v1/crm/leads/timeline`,
//       data: { leadId: Number(leadId) },
//     });
//     console.log("response", response);
//   } catch (err) {
//     console.log("err", err);
//   }
// };

export const getTimeline = async (leadId: string | number) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
console.log(timeZone);
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
console.log(timeZone);
    // Pass the leadId as a query parameter
    const response = await axiosInstance({
      method: "GET",

      url: `/odoo/api/v1/crm/leads/timeline`,
      params: { leadId: Number(leadId),timeZone:timeZone }, // Parameters are passed in the 'params' field for GET request
    });
    console.log("response", response);
    return response.data; // Optionally, return data from the response
  } catch (err) {
    console.log("err", err);
    throw err; // Optionally throw error to handle it in the calling code
  }
};

export const addNote = async (data: object) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/note",
      // params: params,
      // data: data,
      data: data,
    });

    console.log("response", response);

    return response;
  } catch (err) {
    console.log("err", err);
  }
};

export const updateNote = async(data: object) => {
  try{
    const response = await axiosInstance({
      method: "PUT",
      url: "/odoo/api/v1/crm/leads/note",
      data: data,
    });
    console.log("response", response);
    return response.data;
  }
  catch (err) {
    console.log("err", err);
  }
} 

export const saveCRMFilters = async (data: object) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/filters/save",
      data: data,
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

//method to delete a filter
export const deleteCRMFilter = async (filterId: number | undefined) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/filters/delete",
      data: { filterId: filterId },
    });
    return response.data;
  } catch (err) {
    console.log("error", err);
  }
};

// Mock data fetch from API
export const transformToKanban = async (
  stages: IStageGroup[],
  leads: Array<Lead>
): Promise<Column[]> => {
  const transformedStages = stages.map((stage) => {
    // const leadsInStage = leads?.[stage.id as unknown as keyof typeof leads];

    return {
      ...stage,
      id: stage.id,
      name: stage.name,
      items: leads ?? [],
      limit: 5,
    } as Column;
  });

  return transformedStages;
};

// Mock save API (you'd call your actual API endpoint here)
export const saveKanbanData = async (
  updatedColumns: Column[]
): Promise<void> => {
  console.log("Saving kanban data to server...", updatedColumns);
};

export const updateColumnOrder = async (columnIds: number[]) => {
  try {
    const response = await axiosInstance.put("/api/stages/reorder", {
      columnIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating column order:", error);
    return false;
  }
};

export const setPriority = async (lead_id: number, priority: string) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: `/odoo/api/v1/crm/leads/`,
      data: {
        lead_id: Number(lead_id),
        updates: {
          priority: priority,
        },
      },
    });
    console.log("response", response.data);
    return response.data;
  } catch (err) {
    console.error("Error:", err);
  }
};

/* API call for fetching list of attendees */
export const searchAttendees = async (params?: object) => {
  console.log("params", params);
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/calendar/attendees",
      params: params,
    });
    console.log("response", response);
    return response.data.data;
  } catch (err) {
    console.log("err", err);
  }
};

// API call for mark as won the lead
export const markAsWon = async (lead_id: number,payload:{
  addToCompanyProfile:boolean,
  isFeatured:boolean,
  service_type_ids:number[] | string[]
}) => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/crm/leads/${lead_id}/won`,
      data:payload
    });
    toastService.success(response.data.message);
    console.log("response", response.data);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};

export const markAsLost = async (lead_id: number) => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/crm/leads/${lead_id}/lost`,
    });
    toastService.success(response.data.message);
    console.log("response", response.data);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};

export const callTrack = async (leadId: number,phoneNumber:string | boolean) => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/crm/leads/callLog`,
      data:{
        leadId:leadId,
        callLog:phoneNumber
      }
    });
    toastService.success(response.data.message);
    console.log("response", response.data);
    return response.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};

export const editLeadBudget = async (
  lead_id: number,
  expected_revenue: number
) => {
  try {
    const response = await axiosInstance.put("/odoo/api/v1/crm/leads/", {
      lead_id,
      updates: {
        expected_revenue,
      },
    });

    toastService.success(response.data.message);
    console.log("Response:", response.data);
    return response.data;
  } catch (err) {
    console.error("Error updating lead budget:", err);
  }
};

export const editLead = async (lead_id: number, updates: object) => {
  try {
    const response = await axiosInstance.put("/odoo/api/v1/crm/leads/", {
      lead_id,
      updates, // Directly pass updates object with multiple fields
    });

    toastService.success(response.data.message);
    console.log("Response:", response.data);
    return response.data;
  } catch (err) {
    console.error("Error updating lead:", err);
  }
};


export const archiveLead = async (id: number) => {
  try {
    const response = await axiosInstance.post("/odoo/api/v1/crm/leads/archive", { 
      id,
     });
     toastService.success(response?.data?.message);
     console.log("line 705",response?.data?.message)
    console.log("line 704",response)
    return response;
  } catch (error) {
    console.error("error", error);
   
    return null;
  }
};


/* API call for deleting all leads in a stage */
export const deleteLeadsByStageId = async (stageId: number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/deleteAllByStageId",
      data: {
        stageId,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

/* API call for moving all leads from one stage to another */
export const moveLeadsByStageId = async (
  oldStageId: number,
  newStageId: number
) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/leads/moveAllByStageId",
      data: {
        oldStageId,
        newStageId,
      },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

/* API call for fetching filters and group-by options */
export const getFiltersAndGroupBy = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/crm/filtersAndGroups",
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

/* API call to filters fetchGroup */
export const fetchGroups = async (body: Partial<IFetchGroupsBody>) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/fetchGroups",
      data: body,
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

/* API call to filters for fetchProgressBar */
export const fetchProgressBar = async (body: Partial<IFetchGroupsBody>) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/crm/fetchProgressBar",
      data:{
        ...body,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};
